module.exports = __webpack_public_path__ + "static/media/s_sf_6.a07c8236.png";